import React, { Fragment } from 'react';
import { Card, Col, Form, Input, Row } from 'antd';

export default (props) => {

	const { getFieldDecorator } = props.form;

	return (
		<Fragment>
			<Form layout={'vertical'}>
				<Card title="Thông tin nhà cung cấp">
					<Row gutter={12}>
						<Col span={24}>
							<Form.Item label={'Tên nhà cung cấp'} required>
								{getFieldDecorator('name', {
									rules: [{ required: true, message: 'Vui lòng nhập tên nhà cung cấp！' }]
								})(
									<Input maxLength={255} placeholder={'Nhập tên nhà cung cấp'} allowClear />
								)}
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item label={'Số điện thoại'}>
								{getFieldDecorator('phoneNumber', {
									rules: [
										{
											pattern: /^0\d{9}$/,
											message: 'Số điện thoại không hợp lệ!'
										}
									]
								})(
									<Input maxLength={20} placeholder={'Nhập số điện thoại'} allowClear />
								)}
							</Form.Item>
						</Col>
						<Col span={12}>
							<Form.Item label={'Email'}>
								{getFieldDecorator('email', {
									rules: [
										{
											type: 'email',
											message: 'Email không hợp lệ!'
										}
									]
								})(
									<Input maxLength={20} placeholder={'Nhập email'} allowClear/>
								)}
							</Form.Item>
						</Col>
					</Row>
				</Card>
			</Form>
		</Fragment>
	);
};
